module.exports = __webpack_public_path__ + "static/bluedinosaur-e9330b52bceffc7189945ddc3026427f.png";